module.exports = __webpack_public_path__ + "static/media/Loving_Story.c3440d93.svg";